export default "__VITE_ASSET__CEuRGUVR__"